var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKybSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 11,
    rx: 5.5,
    fill: "#4CAF50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.028 6.35L3.464 6.938V8H2.498V3.8H3.464V5.762L5.324 3.8H6.404L4.664 5.672L6.506 8H5.372L4.028 6.35ZM8.65072 6.512V8H7.67872V6.5L6.05272 3.8H7.08472L8.20672 5.666L9.32872 3.8H10.2827L8.65072 6.512ZM13.7324 5.816C13.9724 5.892 14.1604 6.02 14.2964 6.2C14.4324 6.376 14.5004 6.594 14.5004 6.854C14.5004 7.222 14.3564 7.506 14.0684 7.706C13.7844 7.902 13.3684 8 12.8204 8H10.6484V3.8H12.7004C13.2124 3.8 13.6044 3.898 13.8764 4.094C14.1524 4.29 14.2904 4.556 14.2904 4.892C14.2904 5.096 14.2404 5.278 14.1404 5.438C14.0444 5.598 13.9084 5.724 13.7324 5.816ZM11.6144 4.532V5.522H12.5804C12.8204 5.522 13.0024 5.48 13.1264 5.396C13.2504 5.312 13.3124 5.188 13.3124 5.024C13.3124 4.86 13.2504 4.738 13.1264 4.658C13.0024 4.574 12.8204 4.532 12.5804 4.532H11.6144ZM12.7484 7.268C13.0044 7.268 13.1964 7.226 13.3244 7.142C13.4564 7.058 13.5224 6.928 13.5224 6.752C13.5224 6.404 13.2644 6.23 12.7484 6.23H11.6144V7.268H12.7484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKybSm);
export default __webpack_public_path__ + "static/media/kyb-sm.6b9c7b33b69980d2557a18f99d8fddc2.svg";
export { ForwardRef as ReactComponent };